import React, { useRef, useState } from 'react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@roger/ui-components';

interface OverflowTooltipTextProps {
  text: string;
  /** Applied to the truncating element (width constraint, font, etc.). */
  className?: string;
}

/**
 * Single-line truncated text that shows the full text in a tooltip on hover,
 * but only when the text actually overflows its container.
 */
const OverflowTooltipText: React.FC<OverflowTooltipTextProps> = ({
  text,
  className,
}) => {
  const textRef = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState(false);

  const handleOpenChange = (next: boolean) => {
    const el = textRef.current;
    setOpen(next && !!el && el.scrollWidth > el.clientWidth);
  };

  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip open={open} onOpenChange={handleOpenChange}>
        <TooltipTrigger asChild>
          <div
            ref={textRef}
            className={className ? `truncate ${className}` : 'truncate'}
          >
            {text}
          </div>
        </TooltipTrigger>
        <TooltipContent className='max-w-sm whitespace-pre-wrap break-words'>
          {text}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default OverflowTooltipText;
